export default __webpack_public_path__ + "static/media/insta.7005f525.svg";